import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Podpis } from './podpis';

@Component({
  selector: 'app-main-content',
  templateUrl: './main-content.component.html',
  styleUrls: ['./main-content.component.css']
})
export class MainContentComponent implements OnInit {
  podpis: Podpis[];
  id: number;

  baseURL: string = 'http://www.meteo.si/uploads/probase/www/climate/';

  @Input() selected1: Event;
  @Input() selected2: Event;
  @Input() selected3: Event;
  @Input() selected3a: Event;
  @Input() selected3b: Event;
  @Input() selected3c: Event;
  @Input() selected4: Event;
  @Input() selected4a: Event;
  @Input() selected4b: Event;
  @Input() selected4c: Event;
  @Input() selected4d: Event;
  @Input() selected5: Event;
  @Input() selected5a: Event;
  @Input() selected6: Event;
  @Input() selected6a: Event;
  @Input() selected7: Event;
  @Input() selected7a: Event;
  @Input() selected7b: Event;
  @Input() selected7c: Event;
  @Input() selected7d: Event;
  @Input() selected8: Event;
  @Input() selected9: Event;
  @Input() selected10: Event;
  @Input() selected11: Event;
  @Input() selected11a: Event;
  @Input() selected11b: Event;
  @Input() selected11c: Event;
  @Input() selected12: Event;
  @Input() selected13: Event;


  constructor(public router: Router,
              public route: ActivatedRoute) { }

  ngOnInit() {
    this.podpis;
  }

  
  

}
